// Smart Video Manager - Add this to your theme
// This script prevents decorative autoplay videos from being paused when content videos are played

class SmartVideoManager {
  constructor() {
    this.init();
  }
  
  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupVideoHandlers());
    } else {
      this.setupVideoHandlers();
    }
  }
  
  setupVideoHandlers() {
    // Get all videos
    const allVideos = document.querySelectorAll('video');
    const allIframes = document.querySelectorAll('iframe[src*="youtube"], iframe[src*="vimeo"]');
    
    // Store references to decorative vs content videos
    this.decorativeVideos = [];
    this.contentVideos = [];
    
    // Categorize videos
    [...allVideos, ...allIframes].forEach(video => {
      const deferred = video.closest('deferred-media');
      const purpose = deferred?.getAttribute('data-video-purpose');
      
      if (purpose === 'decoration' || deferred?.hasAttribute('autoplay')) {
        this.decorativeVideos.push(video);
      } else {
        this.contentVideos.push(video);
      }
    });
    
    // Override the pause method for decorative videos only
    this.protectDecorativeVideos();
    
    // Add event listeners for content videos
    this.setupContentVideoListeners();
  }
  
  protectDecorativeVideos() {
    this.decorativeVideos.forEach(video => {
      if (video.tagName === 'VIDEO') {
        // Store original pause method
        video._originalPause = video.pause;
        
        // Override pause method
        video.pause = () => {
          // Only pause if explicitly allowed
          if (video.dataset.allowPause === 'true') {
            video._originalPause();
          }
        };
      }
    });
  }
  
  setupContentVideoListeners() {
    this.contentVideos.forEach(video => {
      if (video.tagName === 'VIDEO') {
        video.addEventListener('play', () => {
          // When content video plays, temporarily allow pausing decorative videos
          this.allowPauseDecorative(true);
          
          // After a short delay, protect them again and resume if needed
          setTimeout(() => {
            this.allowPauseDecorative(false);
            this.resumeDecorativeVideos();
          }, 2000);
        });
        
        video.addEventListener('pause', () => {
          // When content video is paused, resume decorative videos
          setTimeout(() => {
            this.resumeDecorativeVideos();
          }, 500);
        });
        
        video.addEventListener('ended', () => {
          // When content video ends, resume decorative videos
          setTimeout(() => {
            this.resumeDecorativeVideos();
          }, 500);
        });
      }
    });
  }
  
  allowPauseDecorative(allow) {
    this.decorativeVideos.forEach(video => {
      if (video.tagName === 'VIDEO') {
        video.dataset.allowPause = allow ? 'true' : 'false';
      }
    });
  }
  
  resumeDecorativeVideos() {
    this.decorativeVideos.forEach(video => {
      if (video.tagName === 'VIDEO' && video.paused) {
        // Check if this video should be autoplaying
        const deferred = video.closest('deferred-media[autoplay]');
        if (deferred) {
          video.play().catch(e => {
            // Autoplay blocked, which is fine
            console.log('Autoplay resume blocked:', e.message);
          });
        }
      }
    });
  }
}

// Initialize the smart video manager
new SmartVideoManager();